<!-- 巡查详情 -->
<template>
  <div class="dialog-patrol">
    <div class="header">
      <div class="title">巡查详情</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="ul">
          <div class="li">
            <div class="li-left">
              巡查范围：<span>{{ xhxqDialogData.xcfw ? xhxqDialogData.xcfw : '' }}</span>
            </div>
            <div class="li-right">
              流域名称：<span>{{ xhxqDialogData.ly ? xhxqDialogData.ly : '' }}</span>
            </div>
          </div>
          <div class="li">
            <div class="li-left">
              巡查人员：<span>{{
                xhxqDialogData.zrrUserName ? xhxqDialogData.zrrUserName : ''
              }}</span>
            </div>
            <div class="li-right">
              巡查频次：<span>{{ xhxqDialogData.pc ? xhxqDialogData.pc : '' }}</span>
            </div>
          </div>
          <div class="li">
            <div class="li-left">
              开始时间：<span>{{ xhxqDialogData.xhjssj ? xhxqDialogData.xhjssj : '' }}</span>
            </div>
            <div class="li-right">
              结束时间：<span>{{ xhxqDialogData.xhkssj ? xhxqDialogData.xhkssj : '' }}</span>
            </div>
          </div>
          <div class="li">
            <div class="li-left">
              巡河距离：<span>{{ xhxqDialogData.xhdx ? xhxqDialogData.xhdx.xcjl : '' }}</span>
            </div>
            <div class="li-right">
              联系方式：<span>{{
                xhxqDialogData.zrrUserTel ? xhxqDialogData.zrrUserTel : ''
              }}</span>
            </div>
          </div>
          <div class="li">
            <div class="li-left">
              网格编号：<span>{{ xhxqDialogData.wgbh ? xhxqDialogData.wgbh : '' }}</span>
            </div>
            <div class="li-right">
              巡河时长：<span>{{ xhxqDialogData.xhdx ? xhxqDialogData.xhdx.xcsc : '' }}</span>
            </div>
          </div>
          <div class="li">
            <div class="li-img">
              <span> 现场照片：</span>
              <img
                v-for="(item, index) in xhxqDialogData.files"
                :key="index"
                :src="item.url"
                alt=""
              />
            </div>
          </div>
          <div class="li">
            <div class="li-map">
              <span> 巡河详情：</span>
              <div id="xhxqMap" ref="xhxqMap" class="map"></div>
              <!-- <img src="~@/assets/img/bg.png" alt="" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted, h } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import { MapService } from '@/utils/mapServices2'
const { proxy } = getCurrentInstance()
const props = defineProps({
  data: Object,
})
const record = ref({})
const api = new Api()
const mapService2 = new MapService()

const xhxqDialogData = ref({})

// 初始化地图
const initMap = () => {
  const center = [xhxqDialogData.value.qdjd, xhxqDialogData.value.qdwd]
  mapService2.initMap(
    {
      container: 'xhxqMap',
      style:
        'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/ht%E6%96%B0%E6%B2%B3%E9%95%BF%E5%A4%A7%E5%B1%8F-%E8%AF%A6%E6%83%85.json',
      center,
      zoom: 14.5,
      minZoom: 9,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  drawLine()
}

const drawLine = () => {
  mapService2.map.once('load', () => {
    const data = [
      {
        coordinates: [xhxqDialogData.value.qdjd, xhxqDialogData.value.qdwd],
        properties: {
          name: xhxqDialogData.value.qdmc,
          icon: '起点.png',
        },
      },
      {
        coordinates: [xhxqDialogData.value.zdjd, xhxqDialogData.value.zdwd],
        properties: {
          name: xhxqDialogData.value.zdmc,
          icon: '终点.png',
        },
      },
    ]

    // 添加上报事件定位图标
    if (xhxqDialogData.value.sbsjs) {
      for (let i = 0; i < xhxqDialogData.value.sbsjs.length; i++) {
        data.push({
          coordinates: [xhxqDialogData.value.sbsjs[i].jd, xhxqDialogData.value.sbsjs[i].wd],
          properties: {
            name: xhxqDialogData.value.sbsjs[i].sjmc,
            icon: '超标报警.png',
          },
        })
      }
    }
    // drawTrajectory(//图层ID字符串自己随便传必须要有，// 轨迹的经纬度坐标为数组，包含轨迹多个点的经纬度，//线颜色(默认 #ffee00)，线宽(默认 8))
    mapService2.drawTrajectory('xhxqMap-1', xhxqDialogData.value.gjs, '#09CEA5', 4)
    mapService2.addPointsLayer('xhxqMapPosition', data, '', 0.9)
  })
}

onMounted(() => {
  api.screen.getWgyXhRecordDetailUsingGet({ id: props.data.id }).then((res) => {
    if (res.code === 200) {
      xhxqDialogData.value = res.data
      initMap()
    }
  })
})
</script>

<style lang="scss" scoped>
.dialog-patrol {
  width: 63.35rem;
  min-width: 63.35rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .ul {
        margin-top: 3.4rem;
      }
      .li {
        display: flex;
        justify-content: space-between;
        align-content: center;
        font-size: 1.4rem;
        color: #ffffff;
        margin-top: 4rem;
        width: 100%;
        &:nth-child(1) {
          margin-top: 0;
        }
        // &:last-child{
        //   margin-top: 2.4rem;
        // }
        .li span {
          font-size: 1.4rem;
          color: #ffffff;
        }
        .li-right {
          text-align: start;
          width: 25rem;
        }
        .li-img img {
          margin-left: 0.5rem;
          &:nth-child(1) {
            margin-left: 0.8rem;
          }
          width: 8.9rem;
          height: 6.7rem;
        }
        .li-img span {
          vertical-align: top;
          margin-top: 0.4rem;
        }
        .li-map span {
          width: 7rem;
          vertical-align: top;
          margin-top: 0.4rem;
        }
        .li-map {
          width: 100%;
        }
        .li-map .map {
          display: inline-block;
          // margin-left: 7rem;
          width: calc(100% - 7.2rem);
          height: 14rem;
          border: 0.1rem solid #48ccdc;
        }
      }
      .title {
        text-align: start;
        font-weight: bold;
        font-size: 2.4rem;
        color: #ffffff;
      }
    }
  }
}
</style>
